import React from 'react';

const NotFound = props => {
    return <div>Page Not Found</div>;
  
}

export default NotFound;